import { render, staticRenderFns } from "./mySearchPages.vue?vue&type=template&id=64c40ec8&scoped=true&"
import script from "./mySearchPages.vue?vue&type=script&lang=js&"
export * from "./mySearchPages.vue?vue&type=script&lang=js&"
import style0 from "./mySearchPages.vue?vue&type=style&index=0&id=64c40ec8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c40ec8",
  null
  
)

export default component.exports